export class InactivityTracker {
  public isActive: boolean;
  protected timeoutId?: NodeJS.Timeout;
  protected onTrackerChange: () => void;

  constructor(protected timeoutMS: number) {
    this.startInactivityTimeout.bind(this);
    this.clearInactivityTimeout.bind(this);
  }

  public init(onTrackerChange: () => void) {
    this.onTrackerChange = onTrackerChange;
    this.isActive = true;
  }

  public destroy() {
    clearTimeout(this.timeoutId);
    this.timeoutId = undefined;
  }

  protected startInactivityTimeout() {
    this.clearInactivityTimeout();

    this.timeoutId = setTimeout(() => {
      if (this.isActive) {
        this.isActive = false;
        this.onTrackerChange();
      }
    }, this.timeoutMS);
  }

  protected clearInactivityTimeout() {
    clearTimeout(this.timeoutId);
    this.timeoutId = undefined;

    if (!this.isActive) {
      this.isActive = true;
      this.onTrackerChange();
    }
  }
}
